import { produce } from 'immer';
import { getComponentEntryQueryKey } from './query.get.js';

function transformComponentEntry(queryClient, entryKey, transformer) {
  const entry = queryClient.getQueryData(getComponentEntryQueryKey(entryKey));
  if (!entry) {
    throw new Error(`transformComponentEntry(${entryKey}): Cannot update entry not yet present`);
  }
  return structuredClone(produce(entry, transformer));
}

export { transformComponentEntry };
//# sourceMappingURL=util.transform-entry.js.map
